import * as ambassadorWixMembersV1SantaMember from './members-v1-santa-member-santa-member.http.js';
import * as ambassadorWixMembersV1SantaMemberTypes from './members-v1-santa-member-santa-member.types.js';
import * as ambassadorWixMembersV1SantaMemberUniversalTypes from './members-v1-santa-member-santa-member.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getMyMemberPage(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1SantaMemberUniversalTypes.GetMyMemberPageRequest,
  ambassadorWixMembersV1SantaMemberTypes.GetMyMemberPageRequest,
  ambassadorWixMembersV1SantaMemberUniversalTypes.GetMyMemberPageResponse,
  ambassadorWixMembersV1SantaMemberTypes.GetMyMemberPageResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1SantaMember.getMyMemberPage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/santa-members/my/page',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSiteMap(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1SantaMemberUniversalTypes.GetSiteMapRequest,
  ambassadorWixMembersV1SantaMemberTypes.GetSiteMapRequest,
  ambassadorWixMembersV1SantaMemberUniversalTypes.GetSiteMapResponse,
  ambassadorWixMembersV1SantaMemberTypes.GetSiteMapResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1SantaMember.getSiteMap(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/santa-members/sitemap',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SantaMember as SantaMemberOriginal,
  GetMyMemberPageRequest as GetMyMemberPageRequestOriginal,
  Config as ConfigOriginal,
  Pattern as PatternOriginal,
  AppData as AppDataOriginal,
  Numbers as NumbersOriginal,
  SeoData as SeoDataOriginal,
  PageRole as PageRoleOriginal,
  RequestInfo as RequestInfoOriginal,
  GetMyMemberPageResponse as GetMyMemberPageResponseOriginal,
  MemberPageResult as MemberPageResultOriginal,
  Head as HeadOriginal,
  PublicData as PublicDataOriginal,
  ViewedUser as ViewedUserOriginal,
  GetSiteMapRequest as GetSiteMapRequestOriginal,
  GetSiteMapResponse as GetSiteMapResponseOriginal,
} from './members-v1-santa-member-santa-member.types.js';
